import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";

import { useGetProjectQuery } from "../../../app/services/projects";
import { useGetCurrentUserQuery } from "../../../app/accounts/authuser";
import { useProjectFieldSync } from "../../../hooks/useProjectFieldSync";
import GuideImage from "../../../components/guide-image/GuideImage";
import TitleBlock from "../../../components/block/TitleBlock";
import Textarea from "../../../components/form-item/Textarea";
import StatusIndicator from "../../../components/status-indicator/StatusIndicator";
import SvgLoadingAnimation from "../../../components/loading/index";

const ProjectOverview = () => {
  const { projectId } = useParams();
  const { data: currentUserData } = useGetCurrentUserQuery();
  const { data: projectData, isLoading } = useGetProjectQuery(
    { project_id: projectId },
    { skip: !projectId || !currentUserData }
  );
  const { updateStatus, debouncedSave } = useProjectFieldSync(projectId);

  const [overview, setOverview] = useState("");
  const initializedRef = useRef(false);

  useEffect(() => {
    if (!initializedRef.current && projectData?.data?.project) {
      setOverview(projectData.data.project.overview || "");
      initializedRef.current = true;
    }
  }, [projectData]);

  const handleChange = (e) => {
    const value = e.target.value;
    setOverview(value);
    debouncedSave({ overview: value });
  };

  if (isLoading) return <SvgLoadingAnimation />;

  return (
    <div className="u-col u-w100 u-gap16">
      <TitleBlock
        title="概要"
        description="プロジェクトの概要と、達成したい具体的な目標を記載できます。参加メンバーと認識を揃えるのに役立ちます。"
      />
      <GuideImage name="project_overview" />
      <Textarea
        label="概要"
        option="optional"
        rows={6}
        placeholder="ここに概要を入力してください。"
        maxLength={1000}
        value={overview}
        onChange={handleChange}
      />
      <StatusIndicator status={updateStatus} />
    </div>
  );
};

export default ProjectOverview;
